import ResourceModel from "models/convention-api/ResourceModel"
import ConventionMeetingAvailability from "models/convention-api/v1/ConventionMeetingAvailability"
import moment from "moment-timezone"

export default class ConventionAvailableMeetingTime extends ResourceModel {
  protected static basePath =
    "/v1/convention_providers/:provider_id/convention_available_meeting_times"

  protected static rels = {
    meetingAvailability: () => ({
      type: ConventionMeetingAvailability,
      from: "meeting_availability_id",
      filterOn: "id",
    }),
  }

  avatar_first_name!: string
  avatar_last_name!: string
  avatar_url!: string
  end_at!: moment.Moment
  start_at!: moment.Moment
  meeting_availability_id!: string

  meetingAvailability?: ConventionMeetingAvailability
}
